import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSwapSlash = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M3.53033 2.46967C3.23744 2.17678 2.76256 2.17678 2.46967 2.46967C2.17678 2.76256 2.17678 3.23744 2.46967 3.53033L20.4697 21.5303C20.7626 21.8232 21.2374 21.8232 21.5303 21.5303C21.8232 21.2374 21.8232 20.7626 21.5303 20.4697L18.1356 17.0749C19.6516 16.5939 20.7501 15.1752 20.7501 13.4999C20.7501 13.0857 20.4143 12.7499 20.0001 12.7499C19.5859 12.7499 19.2501 13.0857 19.2501 13.4999C19.2501 14.7425 18.2428 15.7499 17.0001 15.7499C16.9416 15.7499 16.8846 15.7566 16.8299 15.7693L9.31066 8.25L17.1894 8.25L14.9697 10.4697C14.6768 10.7626 14.6768 11.2374 14.9697 11.5303C15.2626 11.8232 15.7375 11.8232 16.0304 11.5303L19.5304 8.03033C19.671 7.88968 19.75 7.69891 19.75 7.5C19.75 7.30109 19.671 7.11032 19.5304 6.96967L16.0304 3.46967C15.7375 3.17678 15.2626 3.17678 14.9697 3.46967C14.6768 3.76256 14.6768 4.23744 14.9697 4.53033L17.1894 6.75L7.81066 6.75L3.53033 2.46967Z",
			fill: "currentcolor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.97927 8.27764C4.22494 7.94414 4.69444 7.87293 5.02794 8.1186C5.36144 8.36426 5.43264 8.83377 5.18698 9.16727C4.91224 9.54024 4.75012 10 4.75012 10.4999C4.75012 10.9141 4.41434 11.2499 4.00012 11.2499C3.58591 11.2499 3.25012 10.9141 3.25012 10.4999C3.25012 9.6692 3.52111 8.89961 3.97927 8.27764Z",
			fill: "currentcolor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.41501 12.5244C8.7079 12.2315 9.18277 12.2315 9.47567 12.5244C9.76856 12.8173 9.76856 13.2921 9.47566 13.585L7.31079 15.7499L12.3744 15.7499C12.7886 15.7499 13.1244 16.0857 13.1244 16.4999C13.1244 16.9141 12.7886 17.2499 12.3744 17.2499L7.31071 17.2499L9.53038 19.4697C9.82326 19.7626 9.82325 20.2375 9.53035 20.5303C9.23744 20.8232 8.76257 20.8232 8.46969 20.5303L4.96978 17.0302C4.6769 16.7373 4.6769 16.2625 4.96979 15.9696L8.41501 12.5244Z",
			fill: "currentcolor"
		})
	]
});
export default SvgSwapSlash;
